class BlogFilter {
    constructor(formId, buttonId) {
        this.form = document.getElementById(formId);
        this.button = document.getElementById(buttonId);
        this.init();
    }
  
    init() {
        this.button.addEventListener('click', () => this.applyFilters());
        this.updateArticlesShowing();
        this.applyButton();
    }

    applyButton() {
        const checkboxes = this.form.querySelectorAll("input[type='checkbox']");
        const applyButtonCount = this.button.querySelector(".apply-button__count");
        if (checkboxes && applyButtonCount) {
            checkboxes.forEach(checkbox => {
                checkbox.addEventListener('change', () => {
                    this.updateSelectedCount(checkboxes, this.button, applyButtonCount);
                });
            });
        }
    }

    updateSelectedCount(checkboxes, applyButton, applyButtonCount) {
        const selectedFilters = Array.from(checkboxes).filter(checkbox => checkbox.checked).length;
        applyButtonCount.textContent = `(${selectedFilters})`;
    
        if (selectedFilters > 0) {
            applyButton.disabled = false;
        } else {
            applyButton.disabled = true;
        }
    }
    
  
    applyFilters() {
        const filters = this.form.querySelectorAll('input[name="filter"]:checked');
        const selectedFilters = Array.from(filters).map(filter => filter.value);
        const blogUrl = this.form.getAttribute('data-url');
        const baseUrl = location.protocol + '//' + location.host;

        if (selectedFilters.length > 0) {
            if (selectedFilters.includes('all')) {
                window.location.href = baseUrl + blogUrl;
            } else {
                const filterParam = selectedFilters.join(',');
                window.location.href = baseUrl + blogUrl + '/tagged/' + filterParam;
            }
        } else {
            window.location.href = baseUrl + blogUrl;
        }
    }

    updateArticlesShowing() {
        const articleWrap = document.querySelector('.js-article-wrap');
        if (articleWrap) {
            const articles = articleWrap.querySelectorAll('.card-wrapper');
            const articleCount = articles.length;
            const showing = document.querySelector('.js-blogs-showing');
            if (showing) {
                showing.innerHTML = articleCount;
            }
        }
    }


}


new BlogFilter('blog-filter', 'apply-button');
